<template>
  <b-container class="pt-5">
    <b-row
      align-h="center"
      align-v="center"
      class="generatedforms-form rounded"
    >
      <b-col class="p-4">
        <h2>Wygenerowane wnioski</h2>
        <hr />
        <b-table striped hover :items="items" :fields="fields">
          <template v-slot:cell(index)="data">{{
            data.index + 1 + "."
          }}</template>
          <template v-slot:cell(action)="row">
            <b-button @click="download_form(row.index)" class="text-right">
              <b-icon icon="download"></b-icon>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from "vue";

export default {
  name: "GeneratedForms",
  data() {
    return {
      items: [],
      fields: [
        {
          key: "index",
          label: "Lp."
        },
        {
          key: "id",
          sortable: true,
          label: "Id"
        },
        {
          key: "version",
          sortable: true,
          label: "Wersja"
        },
        {
          key: "date",
          sortable: true,
          label: "Data i czas wygenerowania",
          formatter: value => {
            return value.split(".")[0] + " (UTC)";
          }
        },
        {
          key: "action",
          label: "Pobierz"
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(function() {
      var $this = this;
      Vue.CognitoAuth.get_current_user_data().then(function(user_data) {
        if (user_data) {
          $this.user = user_data;
        }
      });
    });
  },
  created() {
    var $this = this;
    Vue.CognitoAuth.get_current_user_data().then(function() {
      Vue.Backend.get_list_generated_forms(
        Vue.CognitoAuth.session.id_token
      ).then(function(json_data) {
        if (json_data.data.message == "success") {
          $this.items = json_data.data.list.reverse();
        } else {
          console.log("Error loading data:", json_data.message);
        }
      });
    });
  },
  methods: {
    download_form: function(index) {
      window.open(this.items[index].url);
    }
  }
};
</script>
<style>
.generatedforms-form {
  background-color: #f8f9fa !important;
}
</style>
